import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { ForgotPasswordForm } from "#app/components/auth/forgot-password-form";

function ForgotPasswordScreen() {
  return (
    <AuthLayout
      heading="Reset Password"
      subheading="Enter the email address associated with your account and we'll send you a link to reset your password."
      footerText="Remember your password?"
      footerLinkText="Log in"
      footerLinkHref="/login"
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/forgot-password")({
  component: ForgotPasswordScreen,
});
